import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWifiWeak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWifiWeak"><Path d="M16.6357 14.103C13.9352 11.9969 10.0672 11.9969 7.36667 14.103L6.13672 12.5259C9.56023 9.85595 14.4422 9.85595 17.8657 12.5259L16.6357 14.103Z" fill="currentColor"/><Path d="M10.7512 18.75C10.7512 19.4404 11.3108 20 12.0012 20C12.6916 20 13.2512 19.4404 13.2512 18.75C13.2512 18.0596 12.6916 17.5 12.0012 17.5C11.3108 17.5 10.7512 18.0596 10.7512 18.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWifiWeak;
